import {
  DocumentNode,
  FetchResult,
  MutationFunctionOptions,
  MutationHookOptions,
  MutationResult,
  OperationVariables,
  useMutation,
} from '@apollo/client';
import { useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useSafeMutation<TData = any, TVariables = OperationVariables>(
  mutation: DocumentNode,
  options?: MutationHookOptions<TData, TVariables>
): [
  (
    options?: MutationFunctionOptions<TData, TVariables>
  ) => Promise<FetchResult<TData> | undefined>,
  MutationResult<TData>
] {
  const isRunning = useRef(false);
  const [mutateFunction, result] = useMutation<TData, TVariables>(
    mutation,
    options
  );

  const safeMutate = async (
    opts?: MutationFunctionOptions<TData, TVariables>
  ): Promise<FetchResult<TData> | undefined> => {
    if (isRunning.current) return undefined;
    isRunning.current = true;
    try {
      return await mutateFunction(opts);
    } finally {
      isRunning.current = false;
    }
  };

  return [safeMutate, result];
}
